/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars */
/**
 * Material-UI component theme overrides
 *
 * Extracted from App.tsx for better organization.
 * Defines consistent styling for MUI components.
 */

import { SPACING, TYPOGRAPHY, LAYOUT } from '../tokens';

export const muiOverrides = {
  MuiAppBar: {
    styleOverrides: {
      root: {
        borderBottom: '1px solid',
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      variant: 'outlined' as const,
    },
  },
  MuiSelect: {
    defaultProps: {
      variant: 'outlined' as const,
    },
  },
  MuiFormControl: {
    defaultProps: {
      variant: 'outlined' as const,
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none', // disable all-caps
        fontWeight: 500,
        minWidth: 'auto',
      },
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none', // also remove hover shadow
        },
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        borderRight: '1px solid',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        boxShadow: 'none',
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        // Add vertical spacing between cards
        '&:not(:last-child)': {
          marginBottom: (theme: { spacing: (value: number) => string }) =>
            theme.spacing(SPACING.sectionVertical),
        },
      },
    },
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        // Consistent padding for all cards
        padding: (theme: { spacing: (value: number) => string }) =>
          theme.spacing(SPACING.cardPadding),
        '&:last-child': {
          paddingBottom: (theme: { spacing: (value: number) => string }) =>
            theme.spacing(SPACING.cardPadding),
        },
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: {
        // Bold headers for MUI tables (matches Datagrid)
        fontWeight: TYPOGRAPHY.tableHeaderWeight,
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        // Consistent row height (matches Datagrid)
        height: `${LAYOUT.tableRowHeight}px`,
      },
    },
  },
  MuiLink: {
    defaultProps: {
      underline: 'none' as const,
    },
    styleOverrides: {
      root: {
        cursor: 'pointer',
        '&:hover': {
          textDecoration: 'none',
        },
      },
    },
  },
};
